module.exports = __webpack_public_path__ + "static/Bwellgym-print-a7def7dc561778862942b7f14336b5e5.jpg";